import React, { Component, Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles';
import { withCookies } from 'react-cookie'
import Container from '@material-ui/core/Container';
import SyncIcon from '@material-ui/icons/Sync';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Toolbar from '@material-ui/core/Toolbar';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import SelectBelow from '../../../custom/SelectBelow';
import Box from '@material-ui/core/Box';
import FormControl from '@material-ui/core/FormControl';
import Add from '@material-ui/icons/Add';
import UsersApi from '../../../../libs/EdgeVMSCloudApi/Users'
import { FetchAccountList } from '../../../../libs/EdgeVMSCloudApi/Accounts'
import Title from '../../../custom/Title'
import PagePaper from '../../../custom/PagePaper'
import CustomTable from '../../../custom/CustomTable';
import CustomTableHead from '../../../custom/CustomTableHead';
import CustomCircularProgress from '../../../custom/CustomCircularProgress';
import SearchBox from '../../../custom/SearchBox'
import { GetNavParamsFromLocation } from '../../../../libs/Utils'
import { NavTableFooter } from '../../../table'
import { SERVICES, OPERATIONS } from '../../../../constants/permissions'
import ROWS_PER_PAGE_OPTIONS from '../../../../constants/navParams'
import { COOKIES } from '../../../../constants/cookieDefs'
import UserActions from './UserActions'

const useStyles = theme => ({
  root: {
    width: '100%',
    overflowX: 'auto',
    display: 'flex',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 240,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  actionsCell: {
    textAlign: 'center',
    whiteSpace: 'nowrap',
  },
});

const userTypes = [
  { key: 'managed', text: "Regular users only" },
  { key: 'tmp',     text: "Temporary users only" }
]

class Users extends Component {
  constructor (props) {
    super(props)

    const { cookies } = props;
    const DefaultNavParams = {
      currentPage: '0',
      rowsPerPage: cookies.get(COOKIES.ROWS_PER_PAGE.name),
      accountFilter: "",
      searchString: '',
      userType: userTypes[0].key
    }

    this.state = {
      isLoading: true,
      userResponse: {},
      accountResponse: {},
      confirmDeleteActionOpen: false,
      showActionProgress: false,
    }

    this.navParams = GetNavParamsFromLocation(DefaultNavParams)
    this.abortController = new AbortController();
    this.signal = this.abortController.signal;
  }

  async componentDidMount () {
    await this.handleRefreshTable()
  }

  componentWillUnmount() {
    this.abortController.abort();
  }

  async handleRefreshTable () {
    const { session } = this.props
    this.setState({isLoading: true})

    let response = await UsersApi.FetchUserList(this.signal, this.navParams)
    if (response.error && response.error.name === "AbortError") {
      return;
    }

    this.setState({userResponse: response.ok ? response.body : {}})

    if (response.ok &&
        session.permissions[SERVICES.ACCOUNT][OPERATIONS.CREATE] &&
        session.permissions[SERVICES.ACCOUNT][OPERATIONS.READ]) {
      response = await FetchAccountList(this.signal)
      if (response.error && response.error.name === "AbortError") {
        return;
      }

      this.setState({accountResponse: response.ok ? response.body : {}})
    } else {
      this.setState({accountResponse: {}})
    }

    this.setState({isLoading: false})
  };

  handleRequestSearch (event, value) {
    let currentParams = new URLSearchParams(window.location.search)
    currentParams.set('currentPage', '0')

    if (value.length) {
      currentParams.set('searchString', value)
    } else {
      currentParams.delete('searchString')
    }

    window.location.search = currentParams.toString()
  };

  onEditClick (user) {
    this.props.history.push(this.props.location.pathname + '/details/' + user,  { originLocation: window.location.toString() })
  }

  handleChangeAccountFilter (event) {
    let currentParams = new URLSearchParams(window.location.search)
    currentParams.set('currentPage', '0')
    currentParams.set('accountFilter', event.target.value)
    window.location.search = currentParams.toString()
  };

  handleChangeUserFilter (event) {
    let currentParams = new URLSearchParams(window.location.search)
    currentParams.set('currentPage', '0')
    currentParams.set('userType', event.target.value)
    window.location.search = currentParams.toString()
  };

  render () {
    const { classes, session } = this.props
    const { userResponse, isLoading, accountResponse} = this.state
    const { currentPage, rowsPerPage, searchString } = this.navParams

    let { total, offset, users } = userResponse
    if (users == null) {
      users = []
    }

    if (total == null) {
      total = 0
    }

    if (offset == null) {
      offset = 0
    }

    let { accounts } = accountResponse
    if (accounts == null) {
      accounts = []
    }

    if (!session.isLoggedIn){
      return null
    }

    return (
      <div className={classes.root}>
        <Container maxWidth="lg" className={classes.container}>
          <PagePaper>
            <Toolbar>
              <Title component="h1" variant="h4">
                Users
              </Title>

              { session.permissions[SERVICES.USER][OPERATIONS.CREATE] &&
                <Tooltip title="Add New User">
                  <span>
                    <IconButton
                      id="add-user-icon"
                      disabled={isLoading}
                      onClick={ () => this.props.history.push(this.props.location.pathname + '/new', { originLocation: window.location.toString() }) }
                    >
                      <Add/>
                    </IconButton>
                  </span>
                </Tooltip>
              }

              <Tooltip title="Refresh">
                <span>
                  <IconButton id="refresh-icon" disabled={isLoading} onClick={this.handleRefreshTable.bind(this)}>
                    <SyncIcon />
                  </IconButton>
                </span>
              </Tooltip>
            </Toolbar>

            <Box display="flex" justifyContent="flex-end">
              { accounts.length > 0 &&
                <FormControl className={classes.formControl} disabled={isLoading}>
                  <InputLabel shrink>
                    Account Filter
                  </InputLabel>
                  <SelectBelow
                    value={accounts.length > 0 ? this.navParams.accountFilter : ""}
                    onChange={this.handleChangeAccountFilter.bind(this)}
                    displayEmpty={accounts.length > 0}
                    className={classes.selectEmpty}
                  >
                    <MenuItem value="">Your Account</MenuItem>
                    {accounts.map((account) => {
                      return <MenuItem key={account.id} value={account.id}>{account.name}</MenuItem>
                    })}
                  </SelectBelow>
                </FormControl>
              }


               <FormControl className={classes.formControl} disabled={isLoading}>
                 <InputLabel shrink>
                   User Filter
                 </InputLabel>
                 <SelectBelow
                   value={this.navParams.userType}
                   onChange={this.handleChangeUserFilter.bind(this)}
                   className={classes.selectEmpty}
                 >
                   {userTypes.map((userType) => {
                     return <MenuItem key={userType.key} value={userType.key}>{userType.text}</MenuItem>
                   })}
                 </SelectBelow>
               </FormControl>

              <SearchBox
                className={classes.formControl}
                disabled={isLoading}
                onSearch={this.handleRequestSearch.bind(this)}
                searchString={searchString}
              />
            </Box>

            { isLoading ? (
              <CustomCircularProgress />
            ) : (
              <Fragment>
                <CustomTable>
                  <CustomTableHead>
                    <TableRow selected={true}>
                      <TableCell>Name</TableCell>
                      <TableCell>Email</TableCell>
                      <TableCell>Username</TableCell>
                      <TableCell>Creation Date</TableCell>
                      <TableCell align="center">Actions</TableCell>
                    </TableRow>
                  </CustomTableHead>

                  {users.length ? (
                    <TableBody>
                      {users.map((user, key) => {
                        let created_at  = new Date(user.created_at)

                        if (this.navParams.accountFilter.length) {
                          if (user.account_id.toString() !== this.navParams.accountFilter) {
                            return null
                          }
                        }

                        return (
                          <TableRow hover={!user.temporary} key={user.id}>
                            <TableCell onClick={user.temporary ? null : this.onEditClick.bind(this, user.id)} title={user.temporary ? null : "Click for details"}>
                              {user.name}
                            </TableCell>
                            <TableCell onClick={user.temporary ? null : this.onEditClick.bind(this, user.id)} title={user.temporary ? null : "Click for details"}>
                              {user.temporary !== 0 ? 'N/A' : user.email}
                            </TableCell>
                            <TableCell onClick={user.temporary ? null : this.onEditClick.bind(this, user.id)} title={user.temporary ? null : "Click for details"}>
                              {user.username}
                            </TableCell>
                            <TableCell onClick={user.temporary ? null : this.onEditClick.bind(this, user.id)} title={user.temporary ? null : "Click for details"}>
                              {created_at.toLocaleString('en-US')}
                            </TableCell>
                            <TableCell className={classes.actionsCell}>
                              <UserActions
                                dense
                                userId={user.id}
                                session={session}
                                federated={user.federated}
                                temporary={user.temporary}
                                onConfirmDelete={async () => await this.handleRefreshTable()}
                              />
                            </TableCell>
                          </TableRow>
                      )})}
                    </TableBody>
                  ) : (
                    <TableBody>
                      <TableRow>
                        <TableCell align='center' colSpan={5}>No Users</TableCell>
                      </TableRow>
                    </TableBody>
                  )}

                  <NavTableFooter
                    labelRowsPerPage='Users per page'
                    rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
                    count={total}
                    rowsPerPage={parseInt(rowsPerPage, 10)}
                    currentPage={total > 0 ? parseInt(currentPage, 10) : 0}
                  />
                </CustomTable>
              </Fragment>
            )}
          </PagePaper>
        </Container>
      </div>
    )
  }
}

export default withCookies(withStyles(useStyles)(Users))
